import * as Sentry from '@sentry/vue'
import { ALLOW_URLS, DENY_URLS, IGNORE_ERRORS } from '@/utils/constants/sentry'
import { beforeSend } from '@/utils/sentry'
const isTestEnv = process.env.TEST === 'true' || process.env.NODE_ENV === 'test' || process.env.VITEST === 'true'

function getSentryIntegrations() {
  if (!import.meta.client) return []

  const router = useRouter()
  const browserTracing = new Sentry.BrowserTracing({
    routingInstrumentation: Sentry.vueRouterInstrumentation(router)
  })

  return [browserTracing]
}

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  async setup(nuxtApp) {
    if (isTestEnv) return

    const vueApp = nuxtApp.vueApp

    const config = useRuntimeConfig()
    const isLocal = config.public.env === 'local'
    const isDev = config.public.env !== 'production'

    if (!config.public.sentryDsn || isLocal) {
      console.warn('Sentry DSN not set, skipping Sentry initialization')
      return
    }

    Sentry.init({
      app: vueApp,
      dsn: config.public.sentryDsn,
      debug: isDev,
      environment: config.public.sentryEnv,
      integrations: getSentryIntegrations(),
      tracesSampleRate: config.public.sentryTracesSampleRate as number,
      normalizeDepth: 5,
      allowUrls: ALLOW_URLS,
      ignoreErrors: IGNORE_ERRORS,
      denyUrls: DENY_URLS,
      beforeSend: (event, hint) => beforeSend(event, hint)
    })
  }
})
